import { configureJotaiStore } from '@/state'
import { Dashboard } from '@/components/dashboard/dashboard'
import { readOnlyRequestAtom } from '@/state/dashboard'
import { getSearchParam } from '@/helpers/url-search-params'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/readOnly')({
  beforeLoad: ({ location }) => {
    const encryptedUrl = getSearchParam(location.search, 'Request')

    const ownerEmail = getSearchParam(location.search, 'ownerEmail')
    const workOrderId = Number(getSearchParam(location.search, 'workOrderId'))

    const store = configureJotaiStore()

    if (encryptedUrl) {
      store.set(readOnlyRequestAtom, { encryptedUrl })
      return
    }

    if (ownerEmail && Number.isInteger(workOrderId) && workOrderId > 0) {
      store.set(readOnlyRequestAtom, { ownerEmail, workOrderId })
      return
    }

    throw redirect({ to: '/login' })
  },
  component: Dashboard,
})
